/**
 * Firebase client SDK initialization.
 * Shares the same Firebase project as pieterstudio.com (pieter-493314).
 * Singleton -- safe to import from multiple files.
 */

import { initializeApp, getApps, type FirebaseApp } from "firebase/app";
import { getAuth, type Auth } from "firebase/auth";

const FIREBASE_CONFIG = {
	apiKey: "AIzaSyCjpvhnGRADIRDG53Or338CE4GpSLFBDFA",
	authDomain: "pieter-493314.firebaseapp.com",
	projectId: "pieter-493314",
};

let app: FirebaseApp;
let auth: Auth;

if (getApps().length === 0) {
	app = initializeApp(FIREBASE_CONFIG);
} else {
	app = getApps()[0]!;
}
auth = getAuth(app);

export { app, auth };
